import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.313 5.114c-1.618 0-2.75 1.129-2.75 2.522v8.728c0 1.393 1.132 2.522 2.75 2.522h14c1.617 0 2.75-1.129 2.75-2.522V7.636c0-1.393-1.133-2.522-2.75-2.522zm-4.25 2.522c0-2.315 1.9-4.022 4.25-4.022h14c2.35 0 4.25 1.707 4.25 4.022v8.728c0 2.315-1.9 4.022-4.25 4.022h-14c-2.35 0-4.25-1.707-4.25-4.022z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12.223 9.602c-.95.056-1.955.67-2.178 1.73-.056.279.168.558.447.613.335.056.614-.111.67-.446.111-.39.558-.78 1.06-.78 0 0 1.005-.057 1.061.947 0 .224-.167.447-.502.781-.056 0-.447.335-.614.503-.168.223-.391.502-.391.892a.56.56 0 0 0 .558.558c.335 0 .391-.335.559-.558l.558-.558c.335-.279.949-.837.949-1.673 0-1.172-1.005-2.064-2.178-2.009Zm-.005 7.852a.873.873 0 1 0 0-1.745.873.873 0 0 0 0 1.745" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M12 6.982c-5.236 0-8.909 1.6-9.818 3.054v-3.49c.182-.728 1.09-2.182 3.273-2.182h13.09c1.091 0 3.273.436 3.273 2.181v3.491C20.545 8.582 17.236 6.982 12 6.982" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.182 6.692v1.195c.577-.329 1.241-.62 1.96-.869C6.945 6.396 9.284 5.982 12 5.982c3.897 0 6.883.857 8.818 1.997V6.545c0-.347-.177-.612-.66-.843-.506-.244-1.164-.338-1.613-.338H5.456c-1.512 0-2.117.898-2.273 1.328Zm-1.97-.39c.27-1.082 1.516-2.938 4.243-2.938h13.09c.643 0 1.621.123 2.479.534.88.423 1.794 1.25 1.794 2.647v6.153l-1.752-2.003C20.057 9.542 17.084 7.982 12 7.982c-2.52 0-4.636.385-6.206.927-1.627.561-2.497 1.23-2.764 1.657l-1.848 2.957v-7.1l.03-.12Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }